import React, { Component } from "react";
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';
import mixin from "../../../utils/mixin";
import consts from "../../../utils/constants";

import './LotTabs.scss';

import LotForm from "../LotForm/LotForm";
import Log from "../Log/Log";
import ReservationForm from "../ReservatinForm/ReservationForm";

const { methods } = mixin;

class LotTabs extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      lot: null,
      prev_lot_id: null,
      reservation: 'reserve',
    };
  }

  renderTitle(){
    if(this.props.lot){
      return `${this.props.lot.name}`;
    }
    return '';
  }

  static getDerivedStateFromProps = (props, state) => {
    let l = null;
    
    if(props.lot_id !== state.prev_lot_id){
      
      if(props.lot){
        l = {...props.lot}
      }

      let resv = props.lot.status == 'SOLD' ? 'view_reservation' : 'reserve';
      
      return{
        prev_lot_id: props.lot_id,
        lot: l,
        reservation: resv,
      }
    }
    return null;
  }

  componentDidMount() {
    
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot_id !== prevProps.lot_id) {
      
    }
  }

  renderStatusLabel = () => {
    if(this.props.lot){
      const object = this.props.lot;
      let status =  this.props.status_array ? this.props.status_array.find(x => x.key == object.status) : null;
      let label = status ? status.label : '-';

      if(object.status == 'SOLD' && object.hasOwnProperty('confirmed') && object.confirmed === false){
        label = 'Apartado en Proceso';
      }

      let color = this.getFillColor(object);
      color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

      return (
        //<span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
        <div className="lot-status-label">
          <span className="status-indicator" style={{backgroundColor: color}}></span> <span>{label}</span>
        </div>
      )
    }
    return '';
  }

  getFillColor(p){
    let status =  this.props.status_array ? this.props.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];
    
  }

  getUserCode = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user.user_code;
  }

  getDefaultTab = () => {
    if(methods.G_canDo(consts.Security.Action.VIEW_LOT_TAB, localStorage.getItem('user'))){
      return 'details';
    }else{
      return 'reservation';
    }
  }

  render() {
    return (
      <div className="containter">
        <h3 className="lot-name">{this.renderTitle()}</h3>
        {this.renderStatusLabel()}
        <div className="clearBoth"></div>
        <button className="btn btn-sm btn-danger btn-add-lot" onClick={this.props.close.bind(this)}>X</button>
        <br/>
        <Tabs defaultActiveKey={this.getDefaultTab()} id="uncontrolled-tab-example" className="mb-3">
          {
            methods.G_canDo(consts.Security.Action.VIEW_LOT_TAB, localStorage.getItem('user')) && 
            <Tab eventKey="details" title="Detalles">
              < LotForm action='update' close={this.props.close} vertical={this.props.vertical} lot={this.props.lot} lot_id={this.props.lot_id} utm={this.props.utm} development_id={this.props.development_id} development={this.props.development} update={this.props.update} update_deleted={this.props.update_deleted} status_array={this.props.status_array} />
            </Tab>
          }
          {
            methods.G_canDo(consts.Security.Action.VIEW_RESERVATION_TAB, localStorage.getItem('user')) && 
            <Tab eventKey="reservation" title="Reservación">
              < ReservationForm action={this.state.reservation} development={this.props.development} close={this.props.close} lot={this.props.lot} lot_id={this.props.lot_id} update={this.props.update} user_code={this.getUserCode()} status_array={this.props.status_array} />
            </Tab>
          }
          {
            methods.G_canDo(consts.Security.Action.VIEW_LOG, localStorage.getItem('user')) && 
            <Tab eventKey="log" title="Bitácora">
              < Log action='log' close={this.props.close} lot={this.props.lot} lot_id={this.props.lot_id} />
            </Tab>
          }
        </Tabs>

        <div className="form-group text-right">
          
        </div>

      </div>
    );
  }

}

export default withRouter(LotTabs);
